import { FILE_TOO_LARGE_MSG, QToastProps, TOTAL_SIZE_EXCEEDED_MSG } from '@qualio/ui-components';

type AttachmentPendoData = {
  company: number;
  product: string;
  type: string;
  designElementId?: string;
};

export class AttachmentEventsHelper {
  static DC_ATTACHMENTS_TOTAL_SIZE_EXCEEDED = 'DC Attachments Total Size Exceeded';
  static DC_ATTACHMENTS_FILE_TOO_LARGE = 'DC Attachments File Too Large';
  static DC_ATTACHMENTS_MAX_FILES = 'DC Attachments Max Files';

  static buildPendoData = (
    company: number,
    product: string,
    type: string,
    designElementId?: string,
  ): AttachmentPendoData => {
    const pendoData: AttachmentPendoData = {
      company,
      product,
      type,
    };
    if (designElementId) {
      pendoData.designElementId = designElementId;
    }
    return pendoData;
  };

  static handleWarning = (
    analytics: SegmentAnalytics.AnalyticsJS,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    warning: any,
    data: AttachmentPendoData,
    showToast?: (options: QToastProps) => void,
  ): void => {
    if (warning.body === 'Max files') {
      analytics.track(AttachmentEventsHelper.DC_ATTACHMENTS_MAX_FILES, data);
      showToast &&
        showToast({
          title: `Too many files`,
          description: 'The total number of files selected exceeds the maximum allowed',
          status: 'error',
          duration: 5000,
        });
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  static handleError = (analytics: SegmentAnalytics.AnalyticsJS, error: any, data: AttachmentPendoData): void => {
    switch (error.main) {
      case TOTAL_SIZE_EXCEEDED_MSG:
        analytics.track(AttachmentEventsHelper.DC_ATTACHMENTS_TOTAL_SIZE_EXCEEDED, data);
        break;
      case FILE_TOO_LARGE_MSG:
        analytics.track(AttachmentEventsHelper.DC_ATTACHMENTS_FILE_TOO_LARGE, data);
        break;
    }
  };
}
